'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { trackAnalyticsEvent } from '@/lib/analyticsTrack';

/** Comptabilise une visite site (1× par session) et la landing sur la page d’accueil. */
export default function SiteAnalytics() {
  const pathname = usePathname();

  useEffect(() => {
    trackAnalyticsEvent('site_visit');
  }, []);

  useEffect(() => {
    if (pathname === '/sign-up-login-screen' || pathname === '/plans' || pathname === '/pwa-open') {
      trackAnalyticsEvent('landing');
    }
  }, [pathname]);

  return null;
}
